import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';

//iconos
import { Create, Add, BeenhereRounded } from '@material-ui/icons';
import { Switch } from '@material-ui/core';

//tabla y card components
import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

//servicios
import { wsGetAll, wsUpdate } from 'services/WService.js';

//modal
import Modal from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

//columnas para llenar la tabla
const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 150 },
  { Header: 'Código', accessor: 'code', width: 200 },
  { Header: 'Nombre mesa', accessor: 'description' },
  { Header: 'Zona', accessor: 'base_zone_description' },
  { Header: 'Divición', accessor: 'divition' },
  { Header: 'Estado', accessor: 'state', width: 200 },
  { Header: 'GPS falso', accessor: 'falseGps', excelEnabled: false, width: 150 },
  { Header: 'Versión', accessor: 'validateVersion', excelEnabled: false, width: 150 },
  { Header: '', accessor: 'actions', excelEnabled: false, width: 0 },
];

export default WithApp(function Bureau(props) {
  const classes = useStyles();

  const [model, setOpen] = useModal(); //uso de las funciones del modal
  const [notify, showNotify] = useToasty(); //notificación despues de las acciones
  const [bureaus, setBureaus] = useState([]); //constante para el listado
  const [dataLoading, setDataLoading] = useState(false);

  //recargar Listado para usar en create y update
  async function listBureaus() {
    setDataLoading(true);
    let response = await wsGetAll('base/bureau');
    setDataLoading(false);
    if (response.success) setBureaus(response.data);
  }

  //aplica una validación a todos los vendedores de la mesa; la otra queda intacta
  async function aplicarValidacion(bureau, campo, activo) {
    setBureaus((previas) =>
      previas.map((item) =>
        item.id === bureau.id ? { ...item, [campo]: activo ? item.vendedores_movil : 0 } : item
      )
    );

    let response = await wsUpdate(`base/bureau/${bureau.id}/validations`, {
      [campo]: activo ? 1 : 0
    });
    if (response.success) showNotify(response.message);
    else showNotify(response.message, 'error');

    listBureaus();
  }

  //el switch va prendido solo si TODOS los vendedores de la mesa lo tienen
  function switchValidacion(bureau, campo) {
    const total = bureau.vendedores_movil || 0;
    return (
      <Switch
        checked={total > 0 && bureau[campo] === total}
        disabled={total === 0}
        onChange={(e) => aplicarValidacion(bureau, campo, e.target.checked)}
        color="secondary"
      />
    );
  }

  useEffect(() => {
    listBureaus();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <Modal model={model} setOpen={setOpen} showNotify={showNotify} reload={listBureaus} />

      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.BASE_BUREAUS_STORE}
              component={
                <CardIcon color="primary">
                  <BeenhereRounded style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de Mesas{dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="Mesas"
              defaultWidth={1200}
              columns={columns}
              data={bureaus.map((item, i) => {
                //mapeando listado para las acciones
                return {
                  num: (
                    <div className="actions-right">
                      {item.id}
                      <AllowedGuard permission={ConstantPermissions.BASE_BUREAUS_UPDATE}>
                        <Button justIcon round simple color="info" onClick={() => setOpen(item)}>
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.BASE_BUREAUS_DELETED}>
                        <ButtonDelete entity="base/bureau" id={item.id} reload={listBureaus} />
                      </AllowedGuard>
                    </div>
                  ),
                  code: item.code,
                  description: item.description,
                  base_zone_description: `${item.zone?.code || ''} - ${
                    item.zone?.description || ''
                  }`,
                  divition: item.divition?.name || '',
                  state: item.state === 'A' ? 'Activo' : 'Inactivo',
                  falseGps: (
                    <AllowedGuard permission={ConstantPermissions.ADMIN_ACCESS_USER}>
                      {switchValidacion(item, 'false_gps')}
                    </AllowedGuard>
                  ),
                  validateVersion: (
                    <AllowedGuard permission={ConstantPermissions.ADMIN_ACCESS_USER}>
                      {switchValidacion(item, 'validate_version')}
                    </AllowedGuard>
                  ),
                  actions: '',
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
